import DefaultModal from "@kopapro/components/commons/modals/defaultModal";
import { withTranslation } from 'react-i18next';

export default withTranslation()(DefaultModal);